module.exports = __webpack_public_path__ + "static/assets/e8128b2b21cb96627a40077faf71cef6.svg";